import React, {useCallback, useEffect, useRef, useState} from "react";
import { Link } from "react-router-dom";
import api from "../../../../services/api";
import BiographyBookMainData from "../BiographyBookMainData";

/**
 * 아카이브 > 회고록 > 메인 > 슬라이드
 */
const BiographySlider = () => {

    const [data, setData] = useState([]);
    const [imgData, setImgData] = useState([]);
    const [isAnimating, setIsAnimating] = useState(false);
    const slidesWrapperRef = useRef(null);
    const slideTimer = useRef(null);
    const [tocsState, setTocsState] = useState({});
    
    const [autoPlayEnabled, setAutoPlayEnabled] = useState(true);
    const autoPlayTimeout = useRef(null);

    const yearRange = Array.from({ length: new Date().getFullYear() - 1800 }, (_, i) => 1800 + i);

    // 이미지 있는 회고록 목록
    const fetchBiographyBooks = async () => {
        try {
            const response = await api.post('/get_books_by_category_and_publish_year_range', {
                book_category: "biography",
                publish_years: yearRange
            });
            const formattedData = response.data.data.map((book) => ({
                book_id: book.book_id,
                n_tocs: book.n_tocs,
            }));
            if (response.status === 200 && response.data) {
                setImgData(formattedData.filter(item => BiographyBookMainData.some(list => item.book_id === list.book_id)));
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        const fetchedData = BiographyBookMainData;
        if (fetchedData.length > 0) {
            const lastItems = fetchedData.slice(-3);
            const filteredArray = fetchedData.slice(0, -3);
            setData([...lastItems.reverse(), ...filteredArray]);
        }
        
        fetchBiographyBooks();
    }, []);

    useEffect(() => {
        if (data.length > 0 && slidesWrapperRef.current) {
            const activeSlide = slidesWrapperRef.current.children[3];
            if (activeSlide) {
                activeSlide.classList.add("biography-slide-active");
            }
        }
        // 각 도서의 book_id마다 목차 존재 여부를 저장하는 객체
        if (imgData.length > 0) {
            const newTocsState = {};
            data.forEach(item => {
                const matchingImg = imgData.find(img => img.book_id === item.book_id);
                if (matchingImg) {
                    newTocsState[item.book_id] = matchingImg.n_tocs > 0;
                }
            });
            setTocsState(newTocsState);
        }
    }, [data, imgData]);

    const moveSlide = useCallback((isPrev = false) => {
        if (isAnimating || !slidesWrapperRef.current) return;

        const wrapper = slidesWrapperRef.current;
        const items = wrapper.children;
        const slideWidth = items[0].offsetWidth;

        items[3].classList.remove("biography-slide-active");
        setIsAnimating(true);

        wrapper.style.transition = "transform 800ms linear";
        wrapper.style.transform = `translateX(${isPrev ? slideWidth : -slideWidth}px)`;

        const handleTransitionEnd = () => {
            wrapper.style.transition = "none";
            wrapper.style.transform = "";
            
            if(!isPrev) {
                // 첫 번째 아이템을 마지막으로 이동
                const firstItem = wrapper.firstElementChild;
                wrapper.appendChild(firstItem);
            } else {
                // 마지막 아이템을 처음으로 이동
                const lastItem = wrapper.lastElementChild;
                wrapper.prepend(lastItem);
            }
            items[3].classList.add("biography-slide-active");
            setIsAnimating(false);
        }

        // CSS 애니메이션이 종료되었을 때 발생
        wrapper.addEventListener('transitionend', handleTransitionEnd, { once: true });
    }, [isAnimating]);

    const handleSlideButtonClick = useCallback((isPrev) => {
        // 자동 재생 중지
        setAutoPlayEnabled(false);
        clearInterval(slideTimer.current);
        
        // 슬라이드 이동
        moveSlide(isPrev);

        // 이전 타임아웃 제거
        clearTimeout(autoPlayTimeout.current);
        
        // 4초 후 자동 재생 재시작
        autoPlayTimeout.current = setTimeout(() => {
            setAutoPlayEnabled(true);
        }, 2000);
    }, [moveSlide]);

    const autoPlay = useCallback(() => {
        if (autoPlayEnabled) {
            clearInterval(slideTimer.current);
            slideTimer.current = setInterval(() => moveSlide(), 4000);
        }
    }, [autoPlayEnabled]);

    useEffect(() => {
        autoPlay();
    }, [autoPlayTimeout, autoPlay]);

    return (
        <div className="archive-slides">
            <div className="slide-control">
                <button 
                    type="button" 
                    className="slides-btn prev"
                    onClick={() => handleSlideButtonClick(true)}
                >
                    이전
                </button>
                <button 
                    type="button" 
                    className="slides-btn next"
                    onClick={() => handleSlideButtonClick(false)}
                >
                    다음
                </button>
            </div>
            <div className="biography-slides">
                <ul 
                    className="slides-wrapper" 
                    ref={slidesWrapperRef}
                    style={{
                        transition: 'transform 500ms linear',
                    }}
                >
                    {data.map((item, index) => (
                        <li 
                            key={index} 
                            className="biography-slide"
                        >
                            {tocsState[item.book_id] ? (
                                <Link
                                    to={`/archive/biography/${item.book_id}`}>
                                    <div className="img-item">
                                        <img src={`/images/biography/` + item.image} alt={item.title} />
                                    </div>
                                </Link>
                            ) : (
                                <div className="img-item">
                                    <img src={`/images/biography/` + item.image} alt={item.title} />
                                </div>
                            )}
                            
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default BiographySlider;
